// Import and register all your controllers from the importmap under controllers/*

import { application } from './application'

// // Eager load all controllers defined in the import map under controllers/**/*_controller
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"
// eagerLoadControllersFrom("controllers", application)

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)

// Manual controller registrations below
import FlatpickrRangesController from './flatpickr_ranges_controller'
application.register('flatpickr-ranges', FlatpickrRangesController)

import CountdownController from './countdown_controller'
application.register('countdown', CountdownController)

import FormValidationController from './form_validation_controller'
application.register('form-validation', FormValidationController)

import NftController from './nft_controller'
application.register('nft', NftController)

import NestedFormController from './nested_form_controller'
application.register('nested-form', NestedFormController)

import DateRangeController from './date_range_controller'
application.register('date-range', DateRangeController)

import Select2Controller from './select2_controller'
application.register('select2', Select2Controller)

import TypingController from './typing_controller'
application.register('typing', TypingController)

import TinymceController from './tinymce_controller'
application.register('tinymce', TinymceController)

import AudienceController from './audience_controller'
application.register('audience', AudienceController)

import AddressController from './address_controller'
application.register('address', AddressController)

import UserController from './user_controller'
application.register('user', UserController)

import TurboFormRequestController from './turbo_form_request_controller'
application.register('turbo-form-request', TurboFormRequestController)

import SlickController from './slick_controller'
application.register('slick', SlickController)

import SearchController from './search_controller'
application.register('search', SearchController)

import UserSelectorController from './user_selector_controller'
application.register('user-selector', UserSelectorController)

import EthereumController from './ethereum_controller'
application.register('ethereum', EthereumController)

import PromotePostController from './promote_post_controller'
application.register('promote-post', PromotePostController)

import RangeSliderController from './range_slider_controller'
application.register('range-slider', RangeSliderController)

import PlacesController from './places_controller'
application.register('places', PlacesController)

import WalletFilterController from './wallet_filter_controller'
application.register('wallet-filter', WalletFilterController)

import PurchaseAdController from './purchase_ad_controller'
application.register('purchase-ad', PurchaseAdController)

import NavigationUrlController from './navigation_url_controller'
application.register('navigation-url', NavigationUrlController)

import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

import HelpDeskController from './help_desk_controller'
application.register('help-desk', HelpDeskController)

import LinkController from './link_controller'
application.register('link', LinkController)

import DecimalLimitController from './decimal_limit_controller'
application.register('decimal-limit', DecimalLimitController)

import PhoneNumberController from './phone_number_controller'
application.register('phone-number', PhoneNumberController)

import MediaTypeController from './media_type_controller'
application.register('media-type', MediaTypeController)

import TagsInputController from './tags_input_controller'
application.register('tags-input', TagsInputController)

import BidController from './bid_controller'
application.register('bid', BidController)

import PurchaseAdUserController from './purchase_ad_user_controller'
application.register('purchase-ad-user', PurchaseAdUserController)

import ShowMoreController from './show_more_controller'
application.register('show-more', ShowMoreController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import ConfirmationController from './confirmation_controller'
application.register('confirmation', ConfirmationController)

import RoomListController from './room_list_controller'
application.register('room-list', RoomListController)

import MediaController from './media_controller'
application.register('media', MediaController)

import MessageController from './message_controller'
application.register('message', MessageController)

import TurboController from './turbo_controller'
application.register('turbo', TurboController)

import JumpController from './jump_controller'
application.register('jump', JumpController)

import GifpickerController from './gifpicker_controller'
application.register('gifpicker', GifpickerController)

import ScrollController from './scroll_controller'
application.register('scroll', ScrollController)

import FlatpickrController from './flatpickr_controller'
application.register('flatpickr', FlatpickrController)

import ReadRoomsController from './read_rooms_controller'
application.register('read-rooms', ReadRoomsController)

import TimepickerController from './timepicker_controller'
application.register('timepicker', TimepickerController)

import LoderController from './loder_controller'
application.register('loder', LoderController)

import OnboardingSignupController from './onboarding_signup_controller'
application.register('onboarding-signup', OnboardingSignupController)

import StripeController from './stripe_controller'
application.register('stripe', StripeController)

import BackskinController from './backskin_controller'
application.register('backskin', BackskinController)

import GoogleMapController from './google_map_controller'
application.register('google-map', GoogleMapController)

import LongPressController from './long_press_controller'
application.register('long-press', LongPressController)

import CropperController from './cropper_controller'
application.register('cropper', CropperController)

import RoomController from './room_controller'
application.register('room', RoomController)

import StripePayoutController from './stripe_payout_controller'
application.register('stripe-payout', StripePayoutController)

import SubmitLoaderController from './submit_loader_controller'
application.register('submit-loader', SubmitLoaderController)

import MetamaskController from './metamask_controller'
application.register('metamask', MetamaskController)

import FormChangeController from './form_change_controller'
application.register('form-change', FormChangeController)

import MessagePreviewController from './message_preview_controller'
application.register('message-preview', MessagePreviewController)

import TurboSubmitController from './turbo_submit_controller'
application.register('turbo-submit', TurboSubmitController)

import DisableClickController from './disable_click_controller'
application.register('disable-click', DisableClickController)

import LibraryController from './library_controller'
application.register('library', LibraryController)

import TooltipController from './tooltip_controller'
application.register('tooltip', TooltipController)

import StripPostController from './strip_post_controller'
application.register('strip-post', StripPostController)

import UserCardController from './user_card_controller'
application.register('user-card', UserCardController)

import ShareController from './share_controller'
application.register('share', ShareController)

import ShowcaseController from './showcase_controller'
application.register('showcase', ShowcaseController)

import MaskController from './mask_controller'
application.register('mask', MaskController)

import InputmaskController from './inputmask_controller'
application.register('inputmask', InputmaskController)

import ResendCodeController from './resend_code_controller'
application.register('resend-code', ResendCodeController)

import QuillController from './quill_controller'
application.register('quill', QuillController)

import DobController from './dob_controller'
application.register('dob', DobController)

import VideoAmbientController from './video_ambient_controller'
application.register('video-ambient', VideoAmbientController)

import EmojiMartDropdownController from './emoji_mart_dropdown_controller'
application.register('emoji-mart-dropdown', EmojiMartDropdownController)

import EmojiMartController from './emoji_mart_controller'
application.register('emoji-mart', EmojiMartController)

import MarkReadController from './mark_read_controller'
application.register('mark-read', MarkReadController)

import OffcanvasController from './offcanvas_controller'
application.register('offcanvas', OffcanvasController)

import NoContextmenuController from './no_contextmenu_controller'
application.register('no-contextmenu', NoContextmenuController)
application.register('offcanvas', OffcanvasController)

import HelperController from './helper_controller'
application.register('helper', HelperController)

import StripeSetupIntentController from './stripe_setup_intent_controller'
application.register('stripe-setup-intent', StripeSetupIntentController)

import CountProgressController from './count_progress_controller'
application.register('count-progress', CountProgressController)

import FancyboxController from './fancybox_controller'
application.register('fancybox', FancyboxController)

import PasswordToggleController from './password_toggle_controller'
application.register('password-toggle', PasswordToggleController)

import VisibilityController from './visibility_controller'
application.register('visibility', VisibilityController)

import AudioPlayerController from './audio_player_controller'
application.register('audio-player', AudioPlayerController)

import NavigationController from './navigation_controller'
application.register('navigation', NavigationController)

import CursorPaginationController from './cursor_pagination_controller'
application.register('cursor-pagination', CursorPaginationController)
